import React, { Component } from 'react'
import { connect } from 'react-redux'
import AnimateHeight from 'react-animate-height'

import { PermissionHelper } from 'helpers'

class MenuItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      updated: Date.now()
    }

    this.checkOpen(this.props.sidebar)
  }

  /**
   * Executes callback if there are namespaces to highlight for current view.
   * @param {Array} highlights
   * @param {Function} callback
   */
  componentWillReceiveProps (nextProps) {
    if (!this.props.match || !nextProps.match) return
    if (this.props.match.url !== nextProps.match.url || this.props.sidebar !== nextProps.sidebar) return this.checkOpen(nextProps.sidebar)
  }

  checkHighlight (highlights, callback) {
    if (highlights) {
      highlights.map(namespace => {
        if (window.location.hash.indexOf(namespace) > -1) {
          callback()
        }
      })
    }
  }

  checkOpen (sidebar) {
    this.state.open = false
    for (let link of this.props.children) {
      if (!link.location) link.location = ''
      if ((!link.external && (link.location.indexOf('http://') > -1 || link.location.indexOf('https://') > -1)) && window.location.hash.indexOf('/flow/embed/' + window.btoa(link.location)) > -1) {
        this.state.open = true
        break
      }
      if (window.location.hash.indexOf(link.location) > -1 && sidebar) {
        this.state.open = true
        break
      }
      this.checkHighlight(link.highlight, () => { this.state.open = true })
    }
  }

  toggle () {
    if (!this.props.sidebar) {
      return
    }
    this.setState({
      open: !this.state.open
    })
  }

  render () {
    if (!this.props.children.filter(obj => (!obj.namespace || !!PermissionHelper.hasPermission(obj.namespace))).length > 0) return false
    return (
      <ul className='menu-wrapper'>
        <li className={'menu-dropdown ' + (this.state.open ? 'active' : '')} onClick={e => this.toggle(e)}>
          <i className={'fa fa-fw ' + (this.props.icon)} />
          <span className='menu-title'>{this.props.title}</span>
          <span className='pull-right menu-angle'><i className={'fa fa-angle-' + (this.state.open ? 'down' : 'left') + ' pull-right'} /></span>
        </li>
        <AnimateHeight duration={500} height={(this.state.open && this.props.sidebar ? 'auto' : '0')}>
          <div className='menu-container'>
            {this.props.children.sort((a, b) => a.order - b.order).map(link => {
              if (link.namespace) {
                if (!PermissionHelper.hasPermission(link.namespace)) return
              }

              var active = window.location.hash.indexOf(link.location) > -1
              if (!link.location) link.location = ''
              if ((!link.external && (link.location.indexOf('http://') > -1 || link.location.indexOf('https://') > -1)) && window.location.hash.indexOf('/flow/embed/' + window.btoa(link.location)) > -1) active = true
              this.checkHighlight(link.highlight, () => { active = true })

              return (
                <li key={this.props.key + link.location} id={active ? 'active-menu-item' : ''}>
                  {(!link.external && (link.location.indexOf('http://') > -1 || link.location.indexOf('https://') > -1)) && <a href={'#/flow/embed/' + window.btoa(link.location)}><i className={active ? 'fa fa-fw fa-circle' : 'fa fa-fw fa-circle-o'} /> {link.text}</a>}
                  {!link.external && (link.location.indexOf('http://') < 0 && link.location.indexOf('https://') < 0) && <a href={link.location} onClick={() => (window.location.hash === link.location && window.location.reload())}><i className={active ? 'fa fa-fw fa-circle' : 'fa fa-fw fa-circle-o'} /> {link.text}</a>}
                  {link.external && <a href={link.location} target='_blank'><i className='fa fa-fw fa-external-link' /> {link.text}</a>}
                </li>
              )
            })}
          </div>
        </AnimateHeight>
      </ul>
    )
  }
}
// eslint-disable-next-line
MenuItem = connect(state => state.siteReducer)(MenuItem)
export default MenuItem



// WEBPACK FOOTER //
// ./src/components/core/menu/Item.js